<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/pc_banner_agent.jpeg`)">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          勝winへようこそ
        </h1>
        <h2 class="subheading">
          「栄華はあなたの望み通り、勝利はあなたの手の中に。」
        </h2>

        <img class="useful-circle-pic" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/agent_one.webp`)">

        <h2 class="subheading">
          勝winとは？
        </h2>
        <p class="content-p-text text_center">
          勝winは2023年に新規オープンした、すべてのゲーム愛好家へ向けたオンラインカジノです。バカラ、ルーレット、スロットマシンなどが楽しめる、
          魅力あふれる「プレミアムオンラインカジノ」体験をご提供いたします。
        </p>
        <p class="content-p-text text_center">
          オンラインカジノを試したいと思っている方は注意が必要です！なぜなら勝winはユニークで刺激的な環境を提供しているからです！ライブを通じてラスベガスのカジノへ行き、実際にゲームをプレイできるのです。ここではディーラーと会話まででき、共にプレイし、まさに現実的なオンライン体験を実現できます。
        </p>

        <h2 class="subheading">
          勝win 安心‧安全にプレイ
        </h2>
        <p class="content-p-text text_center">
          勝winは、Initial Singularity Limitedによって所有および運営されております。
        </p>
        <p class="content-p-text text_center">
          登録番号: 15679 登録住所: Hamchako, Mutsamudu, Autonomous Island of Anjouan Union of
          Comoros.
        </p>

        <img class="useful-circle-pic pic-agent-validSeal" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/agent_validSeal.webp`)" alt="">
        <p class="content-p-text text_center">
          勝winはライセンスを取得しており、コモロ連合アンジュアン自治島政府によって規制されており、ライセンス番号:
          15679に基づいて運営されております。
        </p>
        <p class="content-p-text text_center">
          勝winはすべての規制遵守条件を満たしており、あらゆる賭けとギャンブルのゲームの運営を行う法的権限を与えられております。
        </p>

        <img class="useful-circle-pic" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/agent_two.webp`)" alt="">
        <h2 class="subheading">
          勝winの最新AI技術
        </h2>
        <p class="content-p-text text_center">
          世界最深の暗号化技術により、安心・安全な入出金システムと、高度なAI技術を組み合わせた「独自の2秒で決済」がございます。100％のデータ同期、効率的で信頼性の高い極上のサービスをご提供いたします。
        </p>

        <img class="useful-circle-pic" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/agent_three.webp`)" alt="">
        <h2 class="subheading">
          勝winはお客様に迅速なサービスをご提供いたします
        </h2>
        <p class="content-p-text text_center">
          ゲーム中に予期せぬ事態が発生したお客様は、ルールに関して誤解を抱いたり、サイトの迅速な運営に懸念を抱いたりする可能性がございます。<br>勝winが最も大切にしているのは、顧客サービスシステムでございます。当サイトのサービスにご質問がある場合、またはゲーム内で問題が発生した場合は、カスタマーサービスのチャットシステムを利用し、実際の担当者との会話で問題をご相談くださいませ。または、E-mailに慣れておられる場合は、E-mailでご質問いただくと、すぐに回答を得ることができます。
        </p>

        <img class="useful-circle-pic" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/agent_four.webp`)" alt="">
        <h2 class="subheading">
          華麗な勝利
        </h2>
        <p class="content-p-text text_center">
          人生において、勝利は素晴らしい瞬間と言えるでしょう。
        </p>
        <p class="content-p-text text_center">
          勝利は勇気と忍耐だけでなく、自信を超越すること、そして自信を表現する瞬間でもあります。
        </p>
        <p class="content-p-text text_center">
          華麗な勝利こそ勝winN流、その素晴らしさは達成そのものだけではなく、努力と粘り切った後の誇りと喜びでもあるのです。
        </p>

        <img class="useful-circle-pic" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/agent_five.webp`)" alt="">
        <h2 class="subheading">
          よくある質問
        </h2>
        <ul class="list-type-Q">
          <li>
            <b class="fw_bold">登録する方法は？</b>
            <p>
              【新規登録】をクリックし、登録画面内のすべての情報を入力し、メールアドレスの認証後、約30秒で登録が完了いたします。
            </p>
          </li>

          <li>
            <b class="fw_bold">入出金の方法は？</b>
            <p>
              【銀行の送金、USDT、TigerPayなどの方法で入金と出金が行えます。さらに入金および出金の情報をご覧になりたい場合は、【入金と出金の方法】にてご確認くださいませ
            </p>
          </li>

          <li>
            <b class="fw_bold">新規登録者の入金不要ボーナスを受け取る方法は？</b>
            <p>
              新規登録の後ログインすると、システムより自動でKatsuボーナスウォレット内に送られます。それ以外に特別な操作などはございません。
            </p>
          </li>
        </ul>

        <h2 class="subheading type-sec">
          プレイヤーの皆様が初心者であれ、<br>経験豊富な方であれ、<br>私たちは皆様を最高潮の勝利に導きます。<br>そしてその勝利の味をみんなで味わいましょう！
        </h2>
      </div>
    <!-- content End -->
    </div>
  <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'PageAgent',
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    footerIframe() {
      return 'https://katsuwin.info/iframe/beginner'
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
